'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/8/3.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyExperienceShopInfo = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return _promise2.default.all([dispatch(experienceShopActions.loadShopInfo())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    shopData: state.experienceShop.data,
    error: state.experienceShop.error
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyExperienceShopInfo, _Component);

  function MyExperienceShopInfo() {
    (0, _classCallCheck3.default)(this, MyExperienceShopInfo);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MyExperienceShopInfo).call(this));
  }

  (0, _createClass3.default)(MyExperienceShopInfo, [{
    key: 'render',
    value: function render() {
      var styles = require('./MyExperienceShopInfo.scss');
      var shopData = this.props.shopData;

      var shopShow = _react2.default.createElement('div', null);
      var errorLabel = '';
      if (shopData) {
        var experienceShopInfo = shopData.experienceShopInfo;
        var experienceShopInfoError = shopData.experienceShopInfoError;

        if (experienceShopInfoError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopInfoError });
        } else if (experienceShopInfo instanceof Array && experienceShopInfo.length > 0) {
          shopShow = _react2.default.createElement(
            'div',
            { className: styles.larBox },
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(
                'span',
                null,
                experienceShopInfo[0].shopName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.larAtcoi1 },
              _react2.default.createElement('img', { className: styles.imga1, src: experienceShopInfo[0].img, alt: '' }),
              _react2.default.createElement(
                'ul',
                { className: styles.liea1 },
                _react2.default.createElement(
                  'li',
                  null,
                  '体验店名称: ',
                  experienceShopInfo[0].shopName
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  '店         主: ',
                  experienceShopInfo[0].shopOwner
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  '注 册 时 间: ',
                  experienceShopInfo[0].addTime
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  '详 细 地 址: ',
                  experienceShopInfo[0].address
                )
              ),
              _react2.default.createElement('img', { className: styles.imga2, src: experienceShopInfo[0].QRCode,
                alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.buttonBox },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '', className: styles.buttonAlln },
                '修改'
              )
            )
          );
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        shopShow,
        _react2.default.createElement('div', { className: 'clear' }),
        errorLabel
      );
    }
  }]);
  return MyExperienceShopInfo;
}(_react.Component), _class2.propTypes = {
  shopData: _react.PropTypes.object,
  error: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = MyExperienceShopInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyExperienceShopInfo/MyExperienceShopInfo.js
 ** module id = 1500
 ** module chunks = 0
 **/